// user name
export const STORE_KEY_USERNAME = "org.prolet.tp.client.center.user.name";
// user info
export const STORE_KEY_USERINFO = "org.prolet.tp.client.center.user.info";
// company
export const STORE_KEY_COMPANY = "org.prolet.tp.client.center.user.company";
// local user preferences
export const STORE_KEY_CONFIG_LANG = "org.prolet.tp.client.center.config.lang";
// dashboard related
export const STORE_KEY_DASHBOARD_FILTER = "org.prolet.tp.client.center.dashboard.params";
// my contacts screen filter
export const STORE_KEY_MYCONTACTS_FILTER = "org.prolet.tp.client.center.my.contacts.params";
// cod report screen filter
export const STORE_KEY_CODREPORT_FILTER = "org.prolet.tp.client.center.cod.report.params";
// invoices report screen filter
export const STORE_KEY_INVOICES_FILTER = "org.prolet.tp.client.center.invoices.params";
// single invoice viewer screen
export const STORE_KEY_INVOICE_FILTER = "org.prolet.tp.client.center.single.invoice.params";
// shipment list screen
export const STORE_KEY_SHIPMENT_FILTER = "org.prolet.tp.client.center.shipments.params";
// wms products list screen
export const STORE_KEY_WMS_PRODUCTS_FILTER = "org.prolet.tp.client.center.wms.products.params";
// wms orders (delivery notes) list screen
export const STORE_KEY_WMS_ORDERS_FILTER = "org.prolet.tp.client.center.wms.orders.params";
// Consumables
export const STORE_KEY_CONSUMABLES_PRODUCTS = "org.prolet.tp.client.center.consumables.products.params";
export const STORE_KEY_CONSUMABLES_ORDERS = "org.prolet.tp.client.center.consumables.orders.params";
// shipment request screen
export const STORE_KEY_REQUEST_PREFS = "org.prolet.tp.client.center.shipment.request.prefs";
// export template params
export const STORE_KEY_EXPORT_TEMPLATE = "org.prolet.tp.client.center.export.template";
// notification timestamp since last notify
export const STORE_KEY_NOTIFICATIONS_SINCE = "org.prolet.tp.client.center.notifications.since";
// notification array with notification items meta info
export const STORE_KEY_NOTIFICATIONS_ITEMS = "org.prolet.tp.client.center.notifications.items";
// chat session id
export const STORE_KEY_CHAT_SESSION_ID = "org.prolet.tp.client.center.chat.sessionid";
// email catalog
export const STORE_KEY_EMAIL_CATALOG = "org.prolet.tp.client.center.catalog.email";
